import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'

import { DashboardLayout } from '@components'
import {
  FiltersProvider,
  HandleTicketModalProvider,
  DeleteTicketNotificationProvider,
  HandleDeleteTicketModalProvider,
  ContractFiltersProvider,
  RoutesFiltersProvider,
  DashboardFiltersProvider,
} from '@contexts'
import { useGetConfigurationsData, useLogout } from '@hooks'

import { ProcurementMenu } from './ProcurementMenu'

const selectOptions = [{ value: 'ticketId', label: 'Trip ID' }]

const ProcurementRouter = () => {
  const { logout } = useLogout()
  const { dataConfiguration } = useGetConfigurationsData()

  let tokenExpirationSeconds: number

  useEffect(() => {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < dataConfiguration?.configurationProperties.length; i++) {
      if (dataConfiguration?.configurationProperties[i].key === 'TOKEN_EXPIRATION_SECONDS') {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        tokenExpirationSeconds = dataConfiguration?.configurationProperties[i].value
        break
      }
    }

    setTimeout(() => {
      if (tokenExpirationSeconds !== undefined) {
        logout()
      }
    }, (tokenExpirationSeconds - 1) * 1000)
  }, [dataConfiguration])

  return (
    <DashboardFiltersProvider>
      <DeleteTicketNotificationProvider>
        <HandleTicketModalProvider>
          <HandleDeleteTicketModalProvider>
            <ContractFiltersProvider>
              <RoutesFiltersProvider>
                <FiltersProvider key="filtersProcurement">
                  <DashboardLayout menu={ProcurementMenu} searchSelectOptions={selectOptions}>
                    <Outlet />
                  </DashboardLayout>
                </FiltersProvider>
              </RoutesFiltersProvider>
            </ContractFiltersProvider>
          </HandleDeleteTicketModalProvider>
        </HandleTicketModalProvider>
      </DeleteTicketNotificationProvider>
    </DashboardFiltersProvider>
  )
}

export { ProcurementRouter }
